import React, { useCallback } from "react";

import { InputOnChangeData, SearchBox, SearchBoxChangeEvent, mergeClasses } from "@fluentui/react-components";
import { observer } from "mobx-react";

import { useStyles } from "./M365PulseSearchBox.styles";
import { M365PulseSearchBoxProps } from "./M365PulseSearchBox.types";

const dismissButton = { "aria-label": "Clear search" };

const M365PulseSearchBoxFilterBase = React.forwardRef<HTMLInputElement, M365PulseSearchBoxProps>(
    ({ className, onSearchChange, onValueChange, placeholder = "Search", inputAppearance, customOnKeyDown, clearable = false, ...props }, ref) => {
        const styles = useStyles();
        const inputClass = mergeClasses(styles.input, className?.input);
        const onChange = useCallback(
            (_event: SearchBoxChangeEvent, data: InputOnChangeData) => {
                onValueChange?.(data.value);
                onSearchChange(data.value);
            },
            [onSearchChange, onValueChange]
        );

        return (
            <SearchBox
                ref={ref}
                className={inputClass}
                aria-label={props["aria-label"] ?? "Search"}
                placeholder={placeholder}
                appearance={inputAppearance}
                value={props.value}
                defaultValue={props.defaultValue}
                disabled={props.disabled}
                onChange={onChange}
                onKeyDown={customOnKeyDown}
                dismiss={clearable && !props.disabled ? dismissButton : null}
            />
        );
    }
);

export const M365PulseSearchBoxFilter = observer(M365PulseSearchBoxFilterBase);
